import { SmsTemplateStatus } from "@/models/club";
import { SmsTemplate } from "@/services/discount/type";
import { PlaceHolder } from "@/services/smsPlaceHolders/type";
import { IconAlertTriangle, IconCheck, IconClock, IconDotsVertical, IconPencil, IconSend, IconX } from "@tabler/icons-react";
import { allSmsTypes, faNumber, previewText, smsSegments, smsTypeLabels, splitByPlaceholders, stripOptOut, templateStatus, withOptOut } from "./sms";
import classes from "./sms.module.scss";

type Props = {
  template: SmsTemplate;
  tags: PlaceHolder[];
  onMenu: () => void;
  onEdit: () => void;
  onSend: () => void;
};

const statusIcons = { approved: IconCheck, pending: IconClock, rejected: IconX };

export default function TemplateCard({ template, tags, onMenu, onEdit, onSend }: Props) {
  const status = templateStatus[template.status ?? -1] ?? { label: "نامشخص", tone: "pending" as const };
  const StatusIcon = statusIcons[status.tone];
  const body = stripOptOut(template.text);
  const { segments } = smsSegments(Array.from(withOptOut(previewText(body, tags))).length);
  const uses = template.applicableSmsTypes?.length ? template.applicableSmsTypes : allSmsTypes;

  return (
    <article className={classes.card} style={{ padding: "14px 16px 16px" }}>
      <div className={classes.cardHead}>
        <div className={classes.cardHeadText}>
          <h2 className={classes.cardName}>{template.title}</h2>
          <span className={classes.pill} data-tone={status.tone}>
            <StatusIcon size={14} stroke={2.4} aria-hidden />
            {status.label}
          </span>
        </div>
        <button type="button" className={classes.cardMenu} aria-label={`گزینه‌های قالب ${template.title ?? ""}`} onClick={onMenu}>
          <IconDotsVertical size={22} stroke={1.8} />
        </button>
      </div>

      <p className={classes.messageBox}>
        {splitByPlaceholders(body, tags).map((part, index) =>
          "text" in part ? (
            part.text
          ) : (
            <span key={index} className={classes.token} data-missing={!part.tag.hasValue}>
              {part.tag.value}
            </span>
          ),
        )}
      </p>

      {template.status === SmsTemplateStatus.Value2 && (
        <div className={classes.reasonBox}>
          <div className={classes.reasonText}>
            <IconAlertTriangle size={18} stroke={1.8} aria-hidden />
            <span>
              <strong>دلیل رد:</strong> {template.adminMessage || "دلیلی ثبت نشده است. متن را بازبینی کنید."}
            </span>
          </div>
          <button type="button" className={classes.dangerButton} onClick={onEdit}>
            <IconPencil size={18} stroke={1.8} aria-hidden />
            ویرایش و ارسال دوباره
          </button>
        </div>
      )}

      {template.status === SmsTemplateStatus.Value0 && <p className={classes.pendingNote}>تا وقتی تأیید نشده، در انتخاب متن ارسال‌ها نمایش داده نمی‌شود.</p>}

      <div className={classes.usesRow}>
        <span className={classes.mutedLabel}>قابل استفاده در:</span>
        {uses.map((type) => (
          <span key={type} className={classes.useChip}>
            {smsTypeLabels[type]}
          </span>
        ))}
        <span className={classes.segments}>{faNumber(segments)} پیامک</span>
      </div>

      {template.status === SmsTemplateStatus.Value1 && (
        <button type="button" className={classes.softButton} onClick={onSend}>
          <IconSend size={18} stroke={1.8} aria-hidden />
          ارسال با این قالب
        </button>
      )}
    </article>
  );
}
